var _path, _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomaniaLoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 52.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.21 20.83c3.99 2.49 4.93 7.51 4.93 11.44 0 4.52-.84 10.41-5.54 13.25-3.42 2.07-8.9 2.11-12.37-.69l1.72-2.2c8.87 4.5 12.6-3.24 12.46-8.76-4.82 5.6-15.14 3.97-15.14-5.88.01-6.5 7.37-11.27 13.94-7.16zm.2 9.97c1.34-2.98-.5-8.57-5.26-8.38-2.77.11-4.88 2.75-4.88 5.53 0 6.88 7.76 8.14 10.14 2.85zM33.88 45.48c-4-2.49-4.94-7.51-4.94-11.44 0-4.53.84-10.41 5.54-13.26 3.42-2.07 8.89-2.11 12.37.69l-1.72 2.21c-8.88-4.5-12.6 3.24-12.46 8.75 4.82-5.6 15.14-3.97 15.14 5.88.01 6.51-7.35 11.28-13.93 7.17zm-.19-9.97c-1.34 2.98.49 8.57 5.26 8.38 2.77-.11 4.88-2.75 4.88-5.53 0-6.88-7.76-8.14-10.14-2.85zm48.3 5.07H77.6v6.03h-4v-6.03H61.16v-3.32l11.03-17.38h5.41v17.6h4.39v3.1zm-8.47-3.1.22-14.14-8.28 14.14h8.06zM60.86 19.17h3.48l-13.4 28.79h-3.49z",
    fill: "#f60025"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 15.047,
    cy: 18.783,
    r: 7.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadd84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#dadd84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#dadd84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadd84",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.05 11.55c3.97 0 7.19 3.24 7.19 7.24s-3.22 7.24-7.19 7.24-7.19-3.24-7.19-7.24c-.01-4 3.21-7.24 7.19-7.24z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.852,
    y1: 23.978,
    x2: 14.663,
    y2: 23.978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.66 19.01c-2.12 4.76-6.05 8.76-13.3 10.03-2.94-8.51 7.51-10.66 13.3-10.03z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 5.432,
    y1: 11.491,
    x2: 14.764,
    y2: 11.491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 18.31c-4.46-1.95-8.15-6.1-9.28-13.19 7.87-2.71 9.69 7.48 9.28 13.19z",
    fill: "url(#c)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 17.242,
    y1: 22.285,
    x2: 21.646,
    y2: 31.643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 18.99c3.99 1.74 7.28 5.41 8.29 11.72-7.03 2.41-8.66-6.65-8.29-11.72z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 15.294,
    y1: 14.472,
    x2: 26.088,
    y2: 14.472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.29 18.35c1.41-3.75 5.05-7.13 10.37-7.83 2.31 6.39-5.34 8.35-10.37 7.83z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 0.852,
    y1: 23.977,
    x2: 13.292,
    y2: 23.977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 29.02-.14.03c-2.73-7.88 6.01-10.31 11.93-10.13C7.95 19.66.68 23.1 1.5 29.02z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 9.395,
    y1: 6.814,
    x2: 12.973,
    y2: 20.025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 5.25c-.01-.04-.01-.08-.02-.13 7.27-2.51 9.45 6.25 9.33 11.93-.65-5.23-3.85-12.48-9.31-11.8z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 16.721,
    y1: 19.404,
    x2: 19.748,
    y2: 28.349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 30.59c.01.04.01.08.02.12-6.5 2.23-8.44-5.55-8.33-10.59.59 4.64 3.44 11.08 8.31 10.47z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 17.061,
    y1: 14.531,
    x2: 26.085,
    y2: 14.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17.06 18.43c5.46-1.17 8.64-4.13 8.64-7.79 1.93 5.58-3.83 7.74-8.64 7.79z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 5.744,
    y1: 30.779,
    x2: 14.139,
    y2: 19.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.22 19.17c-2.19 6.18-8 9.53-13.86 9.88 2.8 3.41 7.48 4.03 10.64.92 2.65-2.61 3.16-7.1 3.22-10.8z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 2.656,
    y1: 11.973,
    x2: 14.455,
    y2: 11.973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.45 18.83c-5.88-2.29-9.2-8.07-9.02-13.7-3.5 2.75-3.86 8.55-.09 11.34 2.43 1.79 6.09 2.24 9.11 2.36z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 17.559,
    y1: 18.496,
    x2: 25.679,
    y2: 28.129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 18.54c5.25 2.03 8.21 7.17 8.06 12.17 3.19-2.48 3.31-7.49.01-10.06-2.13-1.66-5.37-2.01-8.07-2.11z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 14.876,
    y1: 13.23,
    x2: 25.674,
    y2: 13.23
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.88 18.17c1.62-4.94 6.27-7.63 10.8-7.81-2.33-2.71-7.09-2.93-9.19.31-1.36 2.09-1.63 5.02-1.61 7.5z",
    fill: "url(#m)",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomaniaLoto);
export default __webpack_public_path__ + "static/media/romania_loto.3a0a4193eaad579170c74c32fcf76010.svg";
export { ForwardRef as ReactComponent };